import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

import { API_URL } from '@/api/client'
import { currentToken } from '@/stores/session'

/**
 * Verbindung zum Reverb-Server der laravel-app.
 *
 * Reverb spricht das Pusher-Protokoll, deshalb der pusher-js-Client.
 *
 * Über diesen Kanal wird ausschließlich EMPFANGEN. Alles, was das Handy sendet,
 * geht über die REST-API - so gibt es genau einen Weg in den Server hinein und
 * genau einen heraus.
 *
 * Die Channel-Autorisierung läuft gegen die laravel-app auf einer anderen
 * Origin und braucht deshalb das Teilnehmer-Token im Header. Es wird bei jedem
 * Aufruf frisch gelesen, damit ein Beitritt nach dem Seitenaufbau nicht auf
 * einem leeren Token sitzen bleibt.
 */
declare global {
    interface Window {
        Pusher: typeof Pusher
    }
}

window.Pusher = Pusher

export const echo: Echo<'reverb'> = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY as string,
    wsHost: import.meta.env.VITE_REVERB_HOST as string,
    wsPort: Number(import.meta.env.VITE_REVERB_PORT ?? 8080),
    wssPort: Number(import.meta.env.VITE_REVERB_PORT ?? 8080),
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME as string) === 'https',
    enabledTransports: ['ws', 'wss'],
    authEndpoint: `${API_URL}/broadcasting/auth`,
    auth: {
        headers: {
            get Authorization(): string {
                return `Bearer ${currentToken() ?? ''}`
            },
        },
    },
})

export default echo
